import 'bootstrap/js/src/collapse'
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.js'

import './Styles.scss'

const scroll = new SmoothScroll('[data-scroll]', {
    speed:  1000,
    offset: function (anchor, toggle) {
        return 59
    }
})
